// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"328":"3290f767","880":"3290f767"}[chunkId] + ".chunk.css";
};